import { Component } from '@angular/core';

@Component({
  selector: 'app-two-fa',
  imports: [],
  templateUrl: './two-fa.component.html',
  styleUrl: './two-fa.component.css',
})
export class TwoFaComponent {

}
